module.exports = __webpack_public_path__ + "assets/img/OG.9307fdba.png";